import css from 'styled-jsx/css';

export const styles = css.global`
    .bottom_right_content_block__description p {
        margin: 0;
        line-height: 1.4em;
    }
    .top_right_content_block__description p {
        margin: 0;
        line-height: 1.4em;
    }
    .bulletContent__description p {
        margin: 0;
        line-height: 1.4em;
    }
`;
